// extracted by mini-css-extract-plugin
module.exports = {"colors":"'../../../variables.css'","notFoundPage":"_2IibAOgJa1kIscfEPfHCq6"};